module.exports = __webpack_public_path__ + "static/media/battery-mid-charge.7f78e00e.png";